import React from 'react';
// import ReactDOM from 'react-dom';
import GongqiFormItem from './GongqiFormItem';
import CommandResolver from '../utils/CommandResolver';
import CommandTask from '../forms/sys/remote/CommandTask';
import TreeRefreshArg from '../forms/sys/remote/TreeRefreshArg';
import Cmd from '../forms/sys/remote/Cmd';
import {CommandMapEditorsStore} from '../stores/CommandStore';
import {RefreshPluginStore} from '../stores/CmdTypeStore';
import {FocusSetStore} from '../stores/FocusStore';
import FocusActions from '../actions/FocusActions';
import ServiceHelper from '../remote/ServiceHelper';
import CommandHelper from '../remote/CommandHelper';
import FormResourceUtil from '../utils/FormResourceUtil';

require('../styles/FormItemPluginStyle.css')

export default class FormItemPluginRadio extends GongqiFormItem
{

	constructor(props)
	{
		super(props);
		
		Object.assign(this.state?this.state:{},{
			tag:false,
			radioArg: "",
			RadioFormGroup: null
		});
		
        this.currentIndex = -1;
		this.selectedValue = "";
		this.serverSelectChange = false;
		this.unsubscribeCommandMapEditorsStore = CommandMapEditorsStore.listen(this.onMapEditorsHandler.bind(this));
		this.unsubscribeRefreshPluginStore = RefreshPluginStore.listen(this.onRefresh.bind(this));
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			let radioInputs = $(this.radioContainer).find("input[type='radio']");
			$(radioInputs[0]).focus();
			this.onTabHandler(-1,pre);
		}
		//$(this.radioContainer).focus();
		//$($(this.radioContainer).find("input.minimal")[0]).focus();
	}

	onTabHandler(currentIndex,pre)
	{
		let radioArg  = this.state.radioArg;
		if(!radioArg)
		{
			radioArg = this.initedRadioArg;
		}
		if(radioArg && radioArg.arg && radioArg.arg.items)
		{
			let length = radioArg.arg.items.length;
			pre?currentIndex--:currentIndex++;
			if(currentIndex<0||currentIndex>=length)
			{
				//todo焦点跳出
				$(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
				FocusActions.focusChange(this.props.xml,pre);
			}
			else
			{
				//由于使用了基于jquery的插件 会自动更改dom 所以不能用状态管理来实现this.setState({currentTabFocusIndex:currentIndex});
				let inputList = $(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
				$(inputList[currentIndex]).addClass("gongqiFocus").find("input[type='radio']").focus();
			}
		}
	}

	componentWillUnmount()
	{
		this.unsubscribeCommandMapEditorsStore();
		this.unsubscribeRefreshPluginStore();
	}

	componentDidMount()
	{
		// $("form-group .iradio_flat-blue .minimal").iCheck({
		// 	checkboxClass: 'icheckbox_minimal-blue14',
		// 	radioClass:'iradio_minimal-blue'
		// });

		$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
			radioClass: 'iradio_minimal-blue'})
		  .on('ifChecked',this.selectedChanged.bind(this,true))
		  .on('ifUnchecked',this.selectedChanged.bind(this,false));
		 
		  if(this.initedSelectedValue)
		  {
			let selectedItemId = this.initedSelectedValue;
			let that = this;
			$(this.radioContainer).find("input[type='radio']").each(function() {
				if($(this).attr("data-serverId") == selectedItemId) {
					//遍历radio组，使用iCheck设置选中项
					that.selectedValue = selectedItemId;
					that.serverSelectChange = true;
					$(this).iCheck('check');
				}
			});
		  }
	}
	
	componentDidUpdate()
	{
		$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
		  radioClass: 'iradio_minimal-blue'})
		.on('ifChecked',this.selectedChanged.bind(this,true))
		.on('ifUnchecked',this.selectedChanged.bind(this,false));

	}

	selectedChanged(value,e)
	{
		
		if(value == true && e.target)
		{
			let mi;let methodName = "pluginRadioItemSelect_" + this.props.xml.name;
			let formModule = this.props.control.module;
			let isLookup = formModule.classAlias == "FormModuleLookup";
			mi = FormResourceUtil.getCommandArgMethodInfo(methodName,isLookup?"FormLookup":formModule.menuItemId,formModule.formId); 
			if(!mi)
				mi = {groups:"current(4)",editors:"all",joinGroup:null,fetchOption:true};

			this.selectedValue = $(e.target).attr("data-serverId");
			let commandArg = CommandResolver.getSendCmd(formModule, this.props.control.groupAlias, mi);
			commandArg.argObject = this.selectedValue;
			
			
			ServiceHelper.addTokenWithCommand({
				command:CommandHelper.createFormInstance(
					formModule.formName, 
					"doPluginRadioItemSelect",
					"CommandResult"
				)
				.appendArg(this.props.xml.name, "String")
				.appendArg(commandArg, "CommandArg"),
				resultFunction:function(data)
				{
					var newCr = data.result;
					if(newCr && newCr.tasks && newCr.tasks.length>0)
					{
						let tasks = newCr.tasks;
						let task = tasks.shift();
						if(task)
							CommandResolver.doResolveTask(task,formModule,tasks);
					}
				}
			});

			/*var arg = {};
			arg.methodName = "pluginRadioItemSelect_" + this.props.xml.name;
			arg.methodArg = $(e.target).attr("data-serverId");
			this.selectedValue = arg.methodArg;
			var commandTask = new CommandTask();
			commandTask.cmd = Cmd.FormCmd;
			commandTask.arg = arg;
			CommandResolver.formCmd(commandTask,this.props.control.module);*/
		}
		
	}


	onRefresh(task,pluginName,formId,result)
	{
		if(this.props.xml.name == pluginName && this.props.formId == formId)
		{
			result.push(this.props.xml.name);
			this.refresh(task);
		}
    }
    
    onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if(this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(selector!="all" && this.props.xml.name != selector)
			return;
		
		mapEditorValues[this.props.xml.name] = this.selectedValue;
	}

	refresh(task)
	{
		console.log(task);
		let _arg = task.arg;
		if(!_arg)
			return;
		if(_arg.opr == "SET_DATA")
		{
			if(_arg.arg && _arg.arg.items && _arg.arg.items.length>0)
			{
				this.selectedValue = _arg.arg.items[0].id;
			}
			this.setState({
				tag:true,
				radioArg: _arg,
			});
		}
		else if(_arg.opr == "SELECT_ITEM")
		{
			let selectedItemId = _arg.arg;
			let that = this;
			if($(this.radioContainer).find("input[type='radio']").length != 0){
				$(this.radioContainer).find("input[type='radio']").each(function() {
					if($(this).attr("data-serverId") == selectedItemId) {
						//遍历radio组，使用iCheck设置选中项
						that.selectedValue = selectedItemId;
						that.serverSelectChange = true;
						$(this).iCheck('check');
					}
				});

			}else{
				setTimeout(() => {
					let that = this;
					$(this.radioContainer).find("input[type='radio']").each(function() {
						if($(this).attr("data-serverId") == selectedItemId) {
							//遍历radio组，使用iCheck设置选中项
							that.selectedValue = selectedItemId;
							that.serverSelectChange = true;
							$(this).iCheck('check');
						}
					});
				}, 350);
			}
		}
	}

	getRadioItems(_layout,radioArg)
	{
		if(!radioArg)
			return null;
		let list = [];
		if(radioArg && radioArg.arg && radioArg.arg.items)
		{
			if(radioArg.arg.label)
			{
				list.push(<label style={{paddingRight:_layout=="vertical"?'0px':'20px',margin:'0px'}}>
						{radioArg.arg.label}
					 </label>);
			}
			for(let i = 0;i<radioArg.arg.items.length;i++)
			{
				let item = radioArg.arg.items[i];
				let uiChild = this.switchRadioArgItems2Dom(item);
				list.push(uiChild);
			}
		}
		
		return list;
	}

	switchRadioArgItems2Dom(item,_layout,i)
	{
		//this.selectedValue = item.id;
		let onFocusHandler=this.pluginOnFocusHandler.bind(this);
		let onBlurHandler=this.pluginOnBlurHandler.bind(this);
		let onTabHandler = this.pluginOnKeyDownHandler.bind(this);
		let inputClass = "minimal";
		return 	<label style={{paddingRight:_layout=="vertical"?'0px':'20px',fontWeight:'200',margin:'0px',marginBottom:_layout=="vertical"?"5px":""}} key={i}>
					<input onKeyDown={onTabHandler} onFocus={onFocusHandler} onBlur={onBlurHandler} type="radio" name={this.props.xml.name} className={inputClass} data-serverId={item.id} data-index={i}/>
					{item.label}
				</label>;
	}

	getMutiRowColChildren(_style,radioArg,count)
	{
		var _layout = radioArg.arg.layout;
		let children = radioArg.arg.items;
		let length = children.length;
		if(_layout == "horizontal")
		{
			
			//var _form:GongqiFormBox = new GongqiFormBox();
			var flatChildren = [];
			var columnChildren = [];
			var _num = 0;
			for(let _i = 0;_i<length;_i++)
			{
				var child = children[_i];
				if(_num<count)
				{
					let uiChild = this.switchRadioArgItems2Dom(child,_layout,_i);
					columnChildren.push(uiChild);
					_num++;
					if(_i == length-1)
					{
						flatChildren.push(columnChildren);
						//(control as Container).addElement(_form);
					}
				}
				else
				{
					_num = 0;
					_i--;
					//(control as Container).addElement(_form);
					flatChildren.push(columnChildren);
					columnChildren = [];
				}
			}
			let resultArr = [];
			for(let i = 0;i<flatChildren.length;i++)
			{
				let itemArray = flatChildren[i];
				resultArr.push(
					<div key={i} style={{display:"flex",flexDirection:"column",alignItems:"stretch"}} className="form-vertical">
						{itemArray}
					</div>
				);
			}
			return resultArr;
		}
		else
		{
			var rowNum = length/count;
			var remainder = length%count;
			if(remainder>0)
				rowNum++;
			
			_num = 0;
			var arr = [];
			for(let _i = 0; _i<count; _i++)
			{
				var subarr = [];
				arr.push(subarr);
			}
			for(let _i = 0; _i<length; _i++)
			{
				child = children[_i];
				if(_num < count)
				{
					arr[_num].push(this.switchRadioArgItems2Dom(child,_layout,_i));
					_num++;
				}
				else
				{
					_num = 0;
					_i--;
				}
			}
			let resultArr = [];
			for(let i = 0;i<arr.length;i++)
			{
				let subarr = arr[i];
				resultArr.push(<div key={i} style={{display:"flex",flexDirection:"column",alignItems:"stretch"}} className="form-vertical">
									{subarr}
								</div>
				);			
			}
			return resultArr;
		}
		
	}

	pluginOnFocusHandler(e)
	{
		//this.currentIndex = -1;
	}

	pluginOnBlurHandler(e)
	{
		//this.currentIndex = -1;
		//$(this.radioContainer).find(".iradio_minimal-blue").removeClass("gongqiFocus");
	}

	pluginOnKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			e.preventDefault();
			let index = $(e.target).attr("data-index");
			this.onTabHandler(index,e.shiftKey);
		}
	}

	render()
	{
		let _style = {display:'flex',flexShrink:'0',alignSelf:'stretch',padding:'5px',flexWrap:'wrap'};
		if(this.state.visible == false)
		{
			if(this.state.hideInVisible == false)
				_style.visibility="hidden";
			else
				_style.display = "none";
		} 
		// var randomNum = Math.floor(Math.random() * 1000) ;
		// $(window.parent.document).find("#gongqi_testthree_406000150").css('height',randomNum+'px')
		
		// $("#DataGrid").height(randomNum)
		//if(this.props.control.getProperty_Height() > 0)
		//	_style["height"] = this.props.control.getProperty_Height() + "px";
		// if(window.parent.toolbarBig == undefined || window.parent.toolbarBig==false){
		// 	$(window.parent.document).find("#contentWrapper").css('paddingBottom',randomNum+'px')
		// }else{
		// 	$(window.parent.document).find("#contentWrapper").css('paddingBottom',randomNum+'px')
		// }

		let list = [];

		let radioArg  = this.state.radioArg;
		if(!radioArg)
		{
			radioArg = this.initedRadioArg;
		}
		if(!radioArg)
		{
			let key = "pluginLaterArg." + this.props.formId + "." + this.props.xml.name;
			if(window.hasOwnProperty(key))
			{
				let pluginLaterArg = window[key];
				if(pluginLaterArg)
				{
					let tasks = pluginLaterArg.tasks;
					for(let i = 0;i<tasks.length;i++)
					{
						pluginLaterArg = tasks[i];
						if(pluginLaterArg)
						{
							if(pluginLaterArg.cmd == "refreshPlugin")
							{
								pluginLaterArg = pluginLaterArg.arg;
								if(pluginLaterArg.opr == "SET_DATA")
								{
									radioArg = pluginLaterArg;
									this.initedRadioArg = radioArg;
								}
								else if(pluginLaterArg.opr == "SELECT_ITEM")
								{
									this.initedSelectedValue = pluginLaterArg.arg;
								}
							}
						}
					}
				}
				
				window[key] = null;
				delete window[key];
			}
		}

		if(!radioArg || !radioArg.arg)
		{
			let _height = this.props.control.getProperty_Height();
			if(_height)
			{
				if(_height<25)_height = 25;
				_style.height = _height+"px";
			}else{
				// _height = 25;
			}
			_style.height=_height;
			// console.log('RadioRend',_height);
			return <div ref={node=>this.radioContainer=node} style={_style} className="formItemPluginRadio" data-xmlid={this.props.xml.id} id={this.props.xml.name}></div>;
		}

		let rowsOrColumns = radioArg.rowsOrColumns;
		//rowsOrColumns=2;
		if(rowsOrColumns)
		{
			let arr =  this.getMutiRowColChildren(_style,radioArg,rowsOrColumns);
			return <div
					ref={node=>this.radioContainer=node} style={_style} className="formItemPluginRadio" data-xmlid={this.props.xml.id} id={this.props.xml.name}>
						{arr}
					</div>
		}

		if(radioArg.arg.layout == "vertical")
		{
			_style.flexDirection = "column";delete _style["flexWrap"];_style.overflowY = "auto";
			let _width = this.props.control.getProperty_Width();
			if(_width>0)
				_style.width = _width+"px";


			let _height = this.props.control.getProperty_Height();
			if(_height)
				_style.height = _height + "px";
			list = this.getRadioItems("vertical",radioArg);
		}
		else
		{
			let _height = this.props.control.getProperty_Height();
			if(_height)
			{
				if(_height<25)_height = 25;
				_style.height = _height+"px";
			}else{
				// _height=25;
				// _style.height = _height+"px";
			}

			
			let _width = this.props.control.getProperty_Width();
			if(_width)
				_style.width = _width+"px";
			list = this.getRadioItems("horizontal",radioArg);
		}
		
			
        return (
			
				
			<div ref={node=>this.radioContainer=node} style={_style} className="formItemPluginRadio" data-xmlid={this.props.xml.id} id={this.props.xml.name}>
				{list}
			</div>
						
			
		
        );
	}

}


// WEBPACK FOOTER //
// ./src/formItem/FormItemPluginRadio.js